package ru.it_mozaika.sender.js.application.components.campaigns

import io.ktor.client.call.*
import js.core.jso
import mui.material.AlertColor
import oldcomponents.NotyType
import org.w3c.dom.url.URLSearchParams
import react.VFC
import react.router.useLocation
import react.router.useNavigate
import react.router.useParams
import react.useEffect
import react.useMemo
import react.useState
import ru.it_mozaika.components.useSnackbar
import ru.it_mozaika.sender.common.models.EmailCampaignData
import ru.it_mozaika.sender.common.models.EmailCampaignStatus
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError
import ru.it_mozaika.sender.js.application.context.CampaignProvider
import ru.it_mozaika.sender.js.application.context.SenderProvider
import ru.it_mozaika.sender.js.application.context.SubscriptionListProvider

val EmailCampaignFrame = VFC {
    val navigate = useNavigate()
    val params = useParams()
    val location = useLocation()
    val showNotification = useSnackbar().enqueueSnackbar

    var campaignId by useState("")
    var campaign by useState<EmailCampaignData>()

    val id = useMemo(params) {
        params["campaignId"].orEmpty()
    }

    useEffect(id) {
        campaignId = if (id != "new") {
            id
        } else {
            URLSearchParams(location.search).get("id").orEmpty()
        }
    }

    useEffect(campaignId, id) {
        if (campaignId.isNotBlank()) {
            Http.get("/campaigns/$campaignId") { response ->
                response.checkResponseError()?.let { error ->
                    showNotification(error, jso { variant = AlertColor.success })
                    navigate("/campaigns")
                    return@get
                }

                val result = response.body<EmailCampaignData>()
                campaign = if (id == "new") {
                    result.copy(id = "", status = EmailCampaignStatus.Template, startDate = null, intelligentSending = false)
                } else {
                    result
                }
            }
        }
    }

    SubscriptionListProvider {
        multiple = false

        SenderProvider {

            CampaignProvider {
                this.campaign = campaign
                if (id == "new" || campaign?.status == EmailCampaignStatus.Template || campaign?.status == EmailCampaignStatus.Pause) {
                    EmailCampaignEditFrame()
                } else if (campaign?.status == EmailCampaignStatus.Complete) {
                    EmailCampaignStatisticsFrame()
                }
            }
        }
    }
}